import React, { ReactNode } from 'react';
import { TypographyP } from '@/Components/shadcn';

interface PaymentSectionProps {
    header: string;
    actionComponent?: ReactNode;
    children: ReactNode;
}

const PaymentSection = ({ header, actionComponent, children }: PaymentSectionProps) => {
    return (
        <div className="flex flex-col">
            <div className="flex flex-row justify-between">
                <TypographyP className="mb-2.5 font-medium">{header}</TypographyP>
                {actionComponent}
            </div>
            {children}
        </div>
    );
};

export default PaymentSection;
